module.exports = __webpack_public_path__ + "static/media/user.b04e3c6d.png";